document.addEventListener('DOMContentLoaded', () => {
  const swiperTabsNavGetInspired = new Swiper('.swiper-tabs-nav-inspired', {
    spaceBetween: 0,
    slidesPerView: 3,
    loop: false,
    loopedSlides: 5,
    autoHeight: false,
    resistanceRatio: 0,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  // Swiper Content
  new Swiper('.swiper-tabs-content-inspired', {
    spaceBetween: 0,
    loop: false,
    direction: 'vertical',
    resistanceRatio: 0,
    watchOverflow: true,
    loopedSlides: 5,
    thumbs: {
      swiper: swiperTabsNavGetInspired,
    },
  });
});
